import { UiService } from '@core/services/ui.services';
import firebase from '@core/settings/firebase-settings';
import { BaseStore } from 'core/base-store';
import { catchError, first, from, map, of } from 'rxjs';

import { UserProfile } from './user-profile.model';
import UserProfileRepository from './user-profile.repository';
import { logger } from '@core/helpers/logger';

const itemInit: UserProfile = new UserProfile();
type IState = {};
const stateInit: IState = {};

export class UserProfileStore extends BaseStore<IState, UserProfile> {
  get sequenceName() {
    return this.repository.collectionName + '-transactionCode';
  }
  seed = 1;
  constructor(uiService: UiService, private repository: UserProfileRepository) {
    super(uiService, stateInit, itemInit);
  }

  load(email: string) {
    this.ui.loader.show();
    return from(this.repository.getByEmail(email)).pipe(
      catchError(error => {
        logger().error(error);
        return of(new UserProfile());
      }),
      map(value => {
        this.updateCurrent(value);
        this.ui.loader.hide();
        return value;
      }),
      first(),
    );
  }

  async save() {
    try {
      const model = this.current;
      const entity = UserProfile.build(model);
      if (!entity.id) {
        entity.id = firebase.currentUserUid();
        this.repository.addUid(entity, firebase.currentUserUid());
        await this.repository.add(entity);
      } else {
        this.repository.addUid(entity, firebase.currentUserUid());
        await this.repository.update(entity.id, entity);
      }
      this.ui.flashMessage.success('Perfil atualizado com sucesso');
    } catch (e: any) {
      this.showValidationMessage(e.message);
    }
  }
}
